import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { CategoryApi } from 'api';

import { RootState } from '../app';

export const findCategory = createAsyncThunk(
  'category/findCategory',
  async (_, { rejectWithValue }) => {
    try {
      const response = await CategoryApi.findMasterData();

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const findCategoryStandardProcess = createAsyncThunk<
  any,
  {
    id: string;
  },
  { rejectValue: { message: string } }
>(
  'category/findCategoryStandardProcess',
  async (params, { rejectWithValue }) => {
    try {
      const response = await CategoryApi.findCategoryStandardProcess(params.id);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

interface IState {
  list: Array<any>;
  listAll: Array<any>;
  mainCategories: any[];
  subCategoriesHash: any;
}

const initialState: IState = {
  list: [],
  listAll: [
    {
      key: 'all',
      value: 'all',
      name: 'Tất cả các danh mục',
    },
  ],
  mainCategories: [],
  subCategoriesHash: {},
};

const categorySlice = createSlice({
  name: 'category',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder.addCase(findCategory.fulfilled, (state, action) => {
      const { data } = action.payload;

      (data || []).forEach((e: any) => {
        const subCategories = e.subCategories?.map((item: any) => {
          return {
            ...item,
            key: item.id,
            value: item.id,
          };
        });

        state.subCategoriesHash[e.id] = subCategories;
      });

      const newData = (data || []).map((item: any) => {
        return {
          ...item,
          key: item.id,
          value: item.id,
        };
      });

      state.list = newData;

      state.listAll = [
        {
          key: 'all',
          value: 'all',
          name: 'Tất cả các danh mục',
        },
        ...newData,
      ];
    });

    builder.addCase(
      findCategoryStandardProcess.fulfilled,
      (state: IState, action: any) => {
        const { data } = action.payload;
        state.mainCategories = data;
      }
    );
  },
});

const { reducer: categoryReducer } = categorySlice;

export default categoryReducer;

export const selectCategory = (state: RootState): IState =>
  state.category as IState;
